module.exports = __webpack_public_path__ + "assets/img/warrior-name-33d10bef.png";